import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Everything below the first viewport is code-split so the Hero (LCP) ships
 * with the smallest possible JS payload. Each block reserves vertical space
 * while its chunk loads, which keeps CLS at zero.
 */
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const ToolboxSection = lazy(() => import('./components/ToolboxSection').then(m => ({
  default: m.ToolboxSection
})));
const DifferentiationSection = lazy(() => import('./components/DifferentiationSection').then(m => ({
  default: m.DifferentiationSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyCta = lazy(() => import('./components/StickyCta').then(m => ({
  default: m.StickyCta
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-cream'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="su45bjsmf6ga" />} data-id="element-0" data-mp="sunby4ctm8f0">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-cream text-ink" data-id="element-2" data-mp="34ndtz6vvc0b">
      <Hero data-id="element-3" data-mp="3udazyhcy738x" />
      <Deferred minHeight="440px" data-id="element-4" data-mp="3ubrgyizwqe3g">
        <PainSection data-id="element-5" data-mp="3uevrrz7vo833" />
      </Deferred>
      <Deferred minHeight="460px" background="bg-blush" data-id="element-6" data-mp="d57g95652mk4">
        <SolutionSection data-id="element-7" data-mp="d2l9v8uzid3h" />
      </Deferred>
      <Deferred minHeight="780px" data-id="element-8" data-mp="851lvh8hilyc">
        <TomosSection data-id="element-9" data-mp="864afiic4cb3" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-blush" data-id="element-10" data-mp="3gle8mfj3sxdl">
        <ToolboxSection data-id="element-11" data-mp="3glwcnyc0cfw2" />
      </Deferred>
      <Deferred minHeight="520px" data-id="element-12" data-mp="3bmbf9schkflg">
        <DifferentiationSection data-id="element-13" data-mp="3bncpxvplb02n" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-blush" data-id="element-14" data-mp="3bkgqg2y3g3c3">
        <BonosSection data-id="element-15" data-mp="3qbzg6sgr9c8n" />
      </Deferred>
      <Deferred minHeight="620px" data-id="element-16" data-mp="3qd0sf09ic4ry">
        <OfferSection data-id="element-17" data-mp="3ljxyus4qcvbr" />
      </Deferred>
      <Deferred minHeight="320px" background="bg-blush" data-id="element-18" data-mp="3lj6b23hdk1w1">
        <GuaranteeSection data-id="element-19" data-mp="2xuddy3p0nnzu" />
      </Deferred>
      <Deferred minHeight="480px" data-id="element-20" data-mp="2xt29e1nqyc7o">
        <FaqSection data-id="element-21" data-mp="2sw20zk3fcxde" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-blush" data-id="element-22" data-mp="2sv0pjeihy8v5">
        <FinalCta data-id="element-23" data-mp="18drg9n2a6z9l" />
      </Deferred>
      <Deferred minHeight="380px" background="bg-blush" data-id="element-24" data-mp="18cq4thhcsarc">
        <Footer data-id="element-25" data-mp="1d4hor9607i8i" />
      </Deferred>
      <Suspense fallback={null} data-id="element-26" data-mp="1d5jbwc0anv6l">
        <StickyCta data-id="element-27" data-mp="1d5ssxa3d2s05" />
      </Suspense>
    </main>;
}